import axios from 'axios';

export const createLead = (lead) => axios.post(`/api/leads`, lead).then((res) => res.data);
export const fetchLead = (leadId) => axios.get(`/api/leads/${leadId}`).then((res) => res.data);
export const updateLead = (leadId, data) => axios.patch(`/api/leads/${leadId}`, data).then((res) => res.data);
export const lookup = async () => axios.get(`/api/leads`).then((res) => res?.data?.content || []);